import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as TeamAgentIcon } from "../../../../../assets/images/People/Groups/team-agent.svg";
import { ReactComponent as TeamChatIcon } from "../../../../../assets/images/People/Groups/team-chat.svg";
import StatusChip from "../../StatusChip";

function TeamCard({ team }) {
  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #E5E9EC",
        background: "#FFF",
        p: 2,
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, mb: 1 }}>
        <Typography
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 16,
            fontWeight: 500,
            lineHeight: "22px",
          }}
        >
          {team.name}
        </Typography>
        <StatusChip status={team.status} />
      </Box>
      <Typography
        sx={{
          color: "#405261",
          fontFamily: "Inter",
          fontSize: 14,
          fontWeight: 400,
          lineHeight: "22px",
          mb: '14px',
        }}
      >
        {team.description}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <TeamAgentIcon style={{ width: 16, height: 16 }} />
          <Typography sx={{ color: "#405261", fontFamily: "Inter", fontSize: 12 }}>
            {team.agents} agents
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <TeamChatIcon style={{ width: 16, height: 16 }} />
          <Typography sx={{ color: "#405261", fontFamily: "Inter", fontSize: 12 }}>
            {team.chats.toLocaleString()} chats
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default function GroupDetailTeamsSection({ teams = [] }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        Teams in this Group
      </Typography>
      {teams.length === 0 ? (
        <Box
          sx={{
            borderRadius: "8px",
            border: "1px solid #E5E9EC",
            background: "#FFF",
            p: 3,
            boxSizing: "border-box",
          }}
        >
          <Typography sx={{ color: "#405261", fontFamily: "Inter", fontSize: 14 }}>
            No teams assigned to this group yet.
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {teams.map((team) => (
            <TeamCard key={team.id} team={team} />
          ))}
        </Box>
      )}
    </Box>
  );
}
